import { useEffect } from 'react';

export const useElementDarkMode = (elementSelector: string, isEnabled = true) => {
  useEffect(() => {
    if (!isEnabled) return;

    const isDarkModeOn = !!document.querySelector('[data-color-scheme="dark"]');

    if (isDarkModeOn) {
      const applyDarkMode = () => {
        const el = document.querySelector(elementSelector);
        if (el) el.setAttribute('data-color-scheme', 'dark');
      };

      applyDarkMode();
      const timer = setTimeout(applyDarkMode, 0);

      return () => {
        clearTimeout(timer);
        const el = document.querySelector(elementSelector);
        if (el) el.removeAttribute('data-color-scheme');
      };
    }
  }, [isEnabled, elementSelector]);
};
